import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../../components/PageHeader";
import StockAlertsTable from "../../../components/Tables/StockAlertsTable";
import {withRouter} from "react-router-dom";
import withPermissions from "../../../components/WithPermissions";
import ManagementPageHero from "../../../components/ManagementPageHero";

class StockAlerts extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div
        className="management-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Stok Uyarıları"
                Breadcrumb={[
                  {name: "Stok Yönetimi", navigate: ""},
                  {name: "Uyarılar", navigate: ""},
                ]}
            />
            <ManagementPageHero
              eyebrow="STOK UYARILARI"
              title="Kritik stokları erkenden görün"
              description="Minimum seviyenin altına düşen veya son kullanma tarihi yaklaşan ürünleri önceliklendirin."
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task management-list-card">
                  <div className="header">
                    <h2>Stok Uyarıları</h2>
                  </div>
                  <div className="body">
                    <div className="alert alert-info">
                      <strong>Bilgi:</strong> Stok uyarıları sistem tarafından otomatik olarak oluşturulur. 
                      Minimum stok seviyesinin altına düşen veya son kullanma tarihi yaklaşan ürünler için uyarılar gösterilir.
                    </div>
                    <StockAlertsTable />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withPermissions(withRouter(connect(mapStateToProps, {})(StockAlerts)));




